import React from 'react';
import { POWERUPS, POWERUP_TYPES } from '../../../economy/economyCatalog';
import CoinIcon from '../../icons/CoinIcon';
import './PowerupsInfoModal.css';

export default function PowerupsInfoModal({ onClose }) {
  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label="Powerups help">
      <div className="modal-content powerups-info-modal">
        <div className="powerups-info-modal__header">
          <h2 className="powerups-info-modal__title">Powerups</h2>
          <button
            type="button"
            className="powerups-info-modal__close"
            onClick={onClose}
            aria-label="Close powerups help"
          >
            ✕
          </button>
        </div>

        <ul className="powerups-info-modal__list">
          <li>
            <strong>{POWERUPS[POWERUP_TYPES.SKIP].label}:</strong>{' '}
            {POWERUPS[POWERUP_TYPES.SKIP].info}{' '}
            <span className="powerups-info-modal__meta">
              Cost: {POWERUPS[POWERUP_TYPES.SKIP].uiCostCoins} <CoinIcon /> (or free if available)
            </span>
          </li>
          <li>
            <strong>{POWERUPS[POWERUP_TYPES.INSPECT].label}:</strong>{' '}
            {POWERUPS[POWERUP_TYPES.INSPECT].info}{' '}
            <span className="powerups-info-modal__meta">
              Cost: {POWERUPS[POWERUP_TYPES.INSPECT].uiCostCoins} <CoinIcon /> (or free if available)
            </span>
          </li>
          <li>
            <strong>{POWERUPS[POWERUP_TYPES.ZOOM_OUT].label}:</strong>{' '}
            {POWERUPS[POWERUP_TYPES.ZOOM_OUT].info}{' '}
            <span className="powerups-info-modal__meta">
              Cost: {POWERUPS[POWERUP_TYPES.ZOOM_OUT].uiCostCoins} <CoinIcon /> (or free if available)
            </span>
          </li>
          <li>
            <strong>{POWERUPS[POWERUP_TYPES.RIDDLE].label}:</strong>{' '}
            {POWERUPS[POWERUP_TYPES.RIDDLE].info}{' '}
            <span className="powerups-info-modal__meta">
              Cost: {POWERUPS[POWERUP_TYPES.RIDDLE].uiCostCoins} <CoinIcon /> base, +
              {POWERUPS[POWERUP_TYPES.RIDDLE].uiRepeatIncrementCoins} <CoinIcon /> each repeat
            </span>
          </li>
        </ul>

        <p className="powerups-info-modal__hint">
          Starter bonus: new players get <strong>3 free Zoom Outs</strong> and <strong>1 free easy riddle</strong>.
        </p>

        <p className="powerups-info-modal__hint">
          Tip: On mobile split view we hide the tiny per-button “i” icons to prevent overlap — use
          this help button instead.
        </p>
      </div>
    </div>
  );
}

